/* library-level-test.js (LT-2, V21, 28 Oct 2026; chat 27 Language learning; D75, D222, D338).
   The free level test: ten screens of six words (tap the ones you know), three sentences, then the result in place.
   Words of the test: assets/library-level-test-<lang>.json (LT-1). Words of the page: the JSON in #lt-cfg (metaobject loa_copy/level_test).
   Scoring is score() below, the same function as website/learn/level-test/score.py (frozen cases in theme-library/tools/lt_score_test.mjs).
   Nothing is sent anywhere unless the visitor asks for the result by e-mail (Klaviyo's client API, the shop's public company id). No analytics, no pixels (D167). */
(function () {
  'use strict';

  /* ---- scoring: identical to score.py ---- */
  function score(data, taps, wrong) {
    /* taps[s][i] true when item i of screen s was tapped; wrong = sentences missed or "not sure" (0..3) */
    var band = {}, madeShown = 0, madeTapped = 0, bands = data.bands;
    bands.forEach(function (b) { band[b.id] = { shown: 0, hit: 0 }; });
    data.screens.forEach(function (sc, s) {
      sc.forEach(function (it, i) {
        var t = !!(taps[s] && taps[s][i]);
        if (it.b === null || it.b === undefined) { madeShown++; if (t) madeTapped++; }
        else if (band[it.b]) { band[it.b].shown++; if (t) band[it.b].hit++; }
      });
    });
    var fa = madeShown ? madeTapped / madeShown : 0, est = 0;
    bands.forEach(function (b) {
      var x = band[b.id], hit = x.shown ? x.hit / x.shown : 0, c = fa < 1 ? Math.max(0, (hit - fa) / (1 - fa)) : 0;
      est += c * (b.to - b.from + 1);
    });
    var level = est >= 8000 ? 'challenging' : est >= 5000 ? 'medium' : 'easy';
    if (wrong >= 2) level = level === 'challenging' ? 'medium' : 'easy';
    var shown = Math.round(est / 100) * 100;
    return { estimate: est, shown: shown, level: level };
  }
  function words(sc) {
    /* how the number is written: "about 6,200", "10,000+", "fewer than 500" */
    var s = sc.shown;
    if (s >= 10000) return { k: 'est_max' };
    if (s < 500) return { k: 'est_min' };
    return { k: 'est_about', n: s.toLocaleString('en-US') };
  }
  function markerAt(est, level) {
    /* the marker sits inside the segment of its level on the drawn scale (Easy 20%, Medium 30%, Challenging 50% of the width) */
    var e = Math.max(0, Math.min(10000, est));
    if (level === 'easy') return Math.min(20, (Math.min(e, 5000) / 5000) * 20);
    if (level === 'medium') return 20 + (Math.max(0, Math.min(e, 8000) - 5000) / 3000) * 30;
    return 50 + (Math.max(0, e - 8000) / 2000) * 50;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { score: score, words: words, markerAt: markerAt }; }
  if (typeof document === 'undefined') { return; }

  /* ---- the page ---- */
  var app = document.getElementById('lt-app'), cfgEl = document.getElementById('lt-cfg');
  if (!app || !cfgEl) { return; }
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var base = String(cfg.base || '').replace(/\/+$/, '');
  var U = cfg.ui || {}, R = cfg.res || {}, lang = cfg.lang, name = cfg.name;
  var els = { eyebrow: document.getElementById('lt-eyebrow'), h1: document.getElementById('lt-h1'), sub: document.getElementById('lt-sub'), body: document.getElementById('lt-body') };
  var data = null, step = 0, taps = [], ans = [], last = null, started = false, stories = 0;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(t, m) { return String(t).replace(/\{(\w+)\}/g, function (a, k) { return m && m[k] !== undefined ? m[k] : a; }); }
  function lv(level) { return R[level] || level; }
  function cls(level) { return level === 'challenging' ? 'hard' : level; }
  function focusQ() { var q = app.querySelector('.lt-q, .ft-out'); if (q) { q.setAttribute('tabindex', '-1'); try { q.focus({ preventScroll: false }); } catch (e) { q.focus(); } } }

  /* ---- steps ---- */
  function total() { return data.screens.length + data.sentences.length; }
  function bar(n) {
    var t = total(), pct = Math.round((n / t) * 100), isSent = n > data.screens.length, lbl = !isSent ? U.step_words : (n === t ? U.step_last : U.step_sent);
    return '<div class="lt-prog"><span class="lt-step">' + esc(fill(lbl, { n: n, t: t })) + '</span><span class="lt-bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + t + '" aria-valuenow="' + n + '" aria-label="' + esc(U.progress) + '"><i style="--p:' + pct + '%"></i></span></div>';
  }
  function showStep() {
    if (step > 0 && els.sub) { els.sub.hidden = true; }
    var n = step + 1, ns = data.screens.length, h;
    if (step < ns) {
      var sc = data.screens[step], t = taps[step] || (taps[step] = []);
      h = '<div class="lt-card" data-lt="' + esc(lang) + '" aria-live="polite">' + bar(n) +
        '<p class="lt-q">' + esc(U.q_words) + '</p><p class="lt-fine lt-hint">' + esc(U.hint) + '</p>' +
        '<div class="lt-words" role="group" aria-label="' + esc(U.words_label) + '">' +
        sc.map(function (it, i) { return '<button type="button" aria-pressed="' + (t[i] ? 'true' : 'false') + '" data-i="' + i + '" lang="' + esc(lang) + '">' + esc(it.w) + '</button>'; }).join('') + '</div>' +
        '<div class="lt-acts"><button class="btn btn-primary" type="button" data-act="next">' + esc(U.cont) + '</button>' + (step > 0 ? '<button class="lt-none" type="button" data-act="back">' + esc(U.back) + '</button>' : '') + '</div>' +
        '<p class="lt-fine">' + esc(U.fine) + '</p></div>';
    } else {
      var k = step - ns, sn = data.sentences[k], a = ans[k], opts = sn.opts.concat([U.unsure]);
      h = '<div class="lt-card lt-sent" data-lt-step="sentence">' + bar(n) +
        '<p class="lt-q">' + esc(U.q_sent) + '</p><p class="lt-s" lang="' + esc(lang) + '">' + esc(sn.s) + '</p>' +
        '<div class="lt-opts" role="radiogroup" aria-label="' + esc(U.answers) + '">' +
        opts.map(function (o, i) { return '<button type="button" role="radio" aria-checked="' + (a === i ? 'true' : 'false') + '" data-o="' + i + '"><span class="lt-rd" aria-hidden="true"></span>' + esc(o) + '</button>'; }).join('') + '</div>' +
        '<div class="lt-acts"><button class="btn btn-primary" type="button" data-act="next">' + esc(n === total() ? U.see : U.cont) + '</button><button class="lt-none" type="button" data-act="back">' + esc(U.back) + '</button></div></div>';
    }
    app.innerHTML = h;
    if (step > 0 || started) { focusQ(); }
  }
  function wrongCount() {
    var w = 0;
    data.sentences.forEach(function (s, k) { if (ans[k] !== s.ok) { w++; } });
    return w;
  }
  function finish() {
    var sc = score(data, taps, wrongCount());
    showResult(sc.shown, sc.level, sc.estimate, true);
  }

  /* ---- result ---- */
  function slug() { return name.toLowerCase(); }
  function bookCard(h) {
    var b = (cfg.books || {})[h]; if (!b) { return ''; }
    var level = last.level, time = b.m ? ' ' + esc(fill(R.read_time, { t: b.m })) : '', badge = '<span class="rl-badge ' + cls(level) + '">' + esc(lv(level)) + '</span>';
    if (b.k === 'story' || b.k === 'poem') {
      var dk = stories++ % 2 === 1;
      return '<li><a href="' + esc(base + '/pages/' + h) + '"><span class="lt-story' + (dk ? ' dk' : '') + '" aria-hidden="true"><i>' + esc(b.k === 'poem' ? R.poem : R.story) + '</i>' + esc(b.t) + '</span><b>' + esc(b.t) + '</b><small>' + badge + time + '</small><span class="lt-read">' + esc(R.read_free) + '</span></a></li>';
    }
    return '<li><a href="' + esc(base + '/products/' + h) + '">' + (b.cover ? '<img src="' + esc(b.cover) + '" width="120" height="180" alt="" loading="lazy" decoding="async">' : '') + '<b>' + esc(b.t) + '</b><small>' + badge + time + '</small><span class="lt-read">' + esc(R.read_free) + '</span></a></li>';
  }
  function listLinks(level) {
    var L = ['easy', 'medium', 'challenging'], out = [];
    function url(l) { return esc(base + '/pages/learn-' + slug() + '-' + l); }
    out.push('<a href="' + url(level) + '">' + esc(fill(R.all_level, { level: lv(level), lang: name })) + '</a>');
    L.forEach(function (l) { if (l !== level) { out.push('<a href="' + url(l) + '">' + esc(lv(l)) + '</a>'); } });
    return '<p class="ft-note">' + out.join(' · ') + '</p>';
  }
  function showResult(shown, level, est, fresh) {
    var w = words({ shown: shown }), phrase = fill(R[w.k], { n: w.n }), h;
    last = { shown: shown, level: level, est: est };
    var handles = [];
    if (data && data.books && data.books[level]) { handles = data.books[level]; }
    stories = 0;
    var cards = handles.map(bookCard).join('');
    h = '<div class="ft-out lt-res" aria-live="polite"><p class="lbl">' + esc(R.lbl) + '</p>' +
      '<p class="rl-lv"><span class="rl-badge ' + cls(level) + '">' + esc(lv(level)) + '</span><span class="rl-gr">' + esc(R.gr) + '</span></p>' +
      '<div class="rl-scale lt-scale" aria-hidden="true"><span>' + esc(R.easy) + '</span><span>' + esc(R.medium) + '</span><span>' + esc(R.challenging) + '</span><i style="--at:' + markerAt(est, level).toFixed(1) + '%"></i></div>' +
      '<p class="lt-line">' + fill(R.line, { level: esc(lv(level)) }) + '</p><p class="lt-why">' + esc(R.why) + '</p>' +
      '<div class="lt-go"><a class="btn btn-gold" href="' + esc(cfg.start) + '" data-start data-learn-from="test-' + esc(lang) + '">' + esc(R.start) + '</a><span class="fine">' + esc(cfg.fine) + '</span></div>' +
      '<p class="lt-share"><a href="#share" data-act="share">' + esc(R.share) + '</a><a href="' + esc(location.pathname) + '">' + esc(R.again) + '</a></p></div>' +
      (cards ? '<h2 class="sbt-h lt-h">' + esc(R.books_h) + '</h2><ul class="lt-books">' + cards + '</ul>' : '<h2 class="sbt-h lt-h">' + esc(R.list_h) + '</h2>') + listLinks(level) +
      '<form class="lt-mail" novalidate><label for="lt-e">' + esc(R.mail_label) + '</label><div class="row"><input id="lt-e" type="email" autocomplete="email" placeholder="' + esc(R.mail_ph) + '"><button class="btn btn-primary" type="submit">' + esc(R.mail_btn) + '</button></div><small>' + esc(R.mail_small) + '</small><label class="lt-opt"><input type="checkbox" name="tips"> ' + esc(R.mail_tips) + '</label><small class="lt-msg" role="status" hidden></small></form>';
    app.innerHTML = h;
    if (R.mail_on === false) { var mf = app.querySelector('.lt-mail'); if (mf) mf.remove(); }   // chat 27: no result mail until chat 26's Klaviyo flow exists (register lt-result-mail)
    if (els.eyebrow) { els.eyebrow.textContent = cfg.eyebrow_res || els.eyebrow.textContent; }
    if (els.h1) { els.h1.textContent = fill(R.h1, { est: phrase, lang: name }); }
    if (els.sub) { els.sub.hidden = true; }
    if (els.body) { els.body.hidden = true; }
    document.title = els.h1 ? els.h1.textContent + ' | Library of Alexandria' : document.title;
    if (fresh) {
      try { history.replaceState(null, '', location.pathname + '?w=' + shown + '&l=' + level); } catch (e) { /* no history */ }
      if (els.h1) { els.h1.setAttribute('tabindex', '-1'); els.h1.focus(); }
    }
    robots();
  }
  function robots() {
    var m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement('meta'); m.setAttribute('name', 'robots'); document.head.appendChild(m); }
    m.setAttribute('content', 'noindex,follow');
  }

  /* ---- start cookie, share, e-mail ---- */
  function setFrom(v) {
    try { document.cookie = 'loa_learn_from=' + encodeURIComponent(v) + '; max-age=2592000; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) { /* cookies off */ }
  }
  /* window, capture phase, on press and on click: the theme's own start-link handler may take the click and leave the page; the cookie is set before it runs */
  function learnFrom(ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('[data-learn-from]') : null;
    if (a) { var v = a.getAttribute('data-learn-from'); setFrom(v === 'test' ? 'test-' + lang : v); }
  }
  window.addEventListener('pointerdown', learnFrom, true);
  window.addEventListener('click', learnFrom, true);
  function share(a) {
    var url = location.origin + location.pathname + '?w=' + last.shown + '&l=' + last.level, title = fill(R.share_title, { lang: name });
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    var done = function () { var old = a.textContent; a.textContent = R.shared; setTimeout(function () { a.textContent = old; }, 2500); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(done, function () {}); }
    else { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) { /* no copy */ } document.body.removeChild(t); }
  }
  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'application/vnd.api+json', revision: cfg.revision || '2026-10-15' }, body: JSON.stringify(body)
    });
  }
  function mail(form) {
    var input = form.querySelector('input[type=email]'), tips = form.querySelector('input[name=tips]'), msg = form.querySelector('.lt-msg'), v = (input.value || '').trim();
    function say(t) { msg.textContent = t; msg.hidden = false; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { say(R.mail_bad); input.focus(); return; }
    if (!cfg.list || !cfg.company) { say(R.mail_err); return; }
    var handles = (data && data.books && data.books[last.level]) || [], names = handles.map(function (h) { return ((cfg.books || {})[h] || {}).t; }).filter(Boolean);
    var props = { lt_lang: lang, lt_estimate: last.shown, lt_level: last.level, lt_tips: !!(tips && tips.checked), lt_books: names.join(' | ') };
    post('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'level-test', profile: { data: { type: 'profile', attributes: { email: v, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } })
      .then(function (r) {
        if (!r.ok) { throw new Error('subscribe ' + r.status); }
        return post('events', { data: { type: 'event', attributes: { properties: { lang: lang, estimate: last.shown, level: last.level, books: names }, unique_id: Date.now().toString(36) + '-' + Math.random().toString(36).slice(2), metric: { data: { type: 'metric', attributes: { name: 'Level test done' } } }, profile: { data: { type: 'profile', attributes: { email: v } } } } } });
      })
      .then(function () { say(R.mail_ok); })
      .catch(function () { say(R.mail_err); });
  }

  /* ---- events ---- */
  app.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target.closest('button, a') : null; if (!t || !app.contains(t)) { return; }
    var ns = data ? data.screens.length : 0;
    if (t.hasAttribute('data-i') && step < ns) {
      var i = +t.getAttribute('data-i'), s = taps[step] || (taps[step] = []);
      s[i] = !s[i]; t.setAttribute('aria-pressed', s[i] ? 'true' : 'false'); return;
    }
    if (t.hasAttribute('data-o')) {
      var k = step - ns, o = +t.getAttribute('data-o');
      ans[k] = o; [].forEach.call(t.parentNode.children, function (b) { b.setAttribute('aria-checked', b === t ? 'true' : 'false'); }); return;
    }
    var act = t.getAttribute('data-act');
    if (act === 'next') { started = true; if (step + 1 >= total()) { finish(); } else { step++; showStep(); } }
    else if (act === 'back') { if (step > 0) { step--; showStep(); } }
    else if (act === 'share') { ev.preventDefault(); share(t); }
  });
  app.addEventListener('submit', function (ev) { if (ev.target.classList.contains('lt-mail')) { ev.preventDefault(); mail(ev.target); } });

  /* ---- start ---- */
  function fromUrl() {
    var q = new URLSearchParams(location.search), w = q.get('w'), l = q.get('l');
    if (w === null || !/^\d{1,5}$/.test(w) || ['easy', 'medium', 'challenging'].indexOf(l) < 0) { return null; }
    var n = Math.min(10000, +w);
    return { shown: Math.round(n / 100) * 100, level: l, est: n };
  }
  var res = fromUrl();
  fetch(app.getAttribute('data-lt-src'), { credentials: 'omit' }).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.json(); }).then(function (d) {
    data = d;
    if (res) { showResult(res.shown, res.level, res.est, false); }
    else { step = 0; showStep(); }
  }).catch(function () {
    if (res) { data = { books: {} }; showResult(res.shown, res.level, res.est, false); return; }
    app.innerHTML = '<div class="lt-card"><p class="lt-q">' + esc(U.load_err) + '</p></div>';
  });
})();
